import type { JSX, ReactNode } from "react";
import { useState } from "react";
import { useLocation } from "react-router";
import { AppSidebar } from "./AppSidebar.js";
import { AppHeader } from "./AppHeader.js";
import { AppDrawer } from "./AppDrawer.js";
import { BottomTabBar } from "./BottomTabBar.js";

export function AppShell({ children }: { children: ReactNode }): JSX.Element {
  const location = useLocation();
  const [drawerOpen, setDrawerOpen] = useState(false);

  // Cook-mode: fullscreen, no chrome
  if (location.pathname.startsWith("/cook/")) {
    return <>{children}</>;
  }

  return (
    <div className="flex min-h-screen bg-zinc-950">
      {/* Desktop sidebar — hidden on mobile */}
      <div className="hidden md:flex">
        <AppSidebar />
      </div>

      {/* Main content area */}
      <div className="flex-1 flex flex-col min-w-0">
        {/* Mobile header — hidden on desktop */}
        <div className="md:hidden">
          <AppHeader onAvatarClick={() => { setDrawerOpen(true); }} />
        </div>

        {/* Page content — single canonical layout for all routes */}
        <main className="flex-1 overflow-y-auto bg-zinc-950 mb-tabbar md:mb-0">
          <div className="mx-auto max-w-5xl px-4 py-6 md:px-8 md:py-8 space-y-6">
            {children}
          </div>
        </main>
      </div>

      {/* Mobile drawer */}
      <AppDrawer open={drawerOpen} onClose={() => { setDrawerOpen(false); }} />

      {/* Mobile bottom tab bar — hidden on desktop, on /cook/*, and when the
          on-screen keyboard is open (BottomTabBar itself decides that). */}
      <BottomTabBar />
    </div>
  );
}
